import Phaser from 'phaser';
import { BootScene } from '@/scenes/BootScene';
import { MenuScene } from '@/scenes/MenuScene';
import { LevelSelectScene } from '@/scenes/LevelSelectScene';
import { LeaderboardScene } from '@/scenes/LeaderboardScene';
import { SingleGameScene } from '@/scenes/SingleGameScene';
import { DailyChallengeScene } from '@/scenes/DailyChallengeScene';
import { DailyShareScene } from '@/scenes/DailyShareScene';
import { CoopGameScene } from '@/scenes/CoopGameScene';
import { TelephoneGameScene } from '@/scenes/TelephoneGameScene';
import { ResultScene } from '@/scenes/ResultScene';
import { DailyResultScene } from '@/scenes/DailyResultScene';
import { SettingsScene } from '@/scenes/SettingsScene';
import { CreditsScene } from '@/scenes/CreditsScene';
import { FriendWebPlayScene } from '@/scenes/FriendWebPlayScene';
import { JoinScene } from '@/scenes/JoinScene';
import { LobbyScene } from '@/scenes/LobbyScene';
import { KickedScene } from '@/scenes/KickedScene';

export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

export const gameConfig: Phaser.Types.Core.GameConfig = {
  // Required for Phaser DOMElement UI (Join inputs, modals).
  // Canvas renderer does not support DOMElement positioning.
  type: Phaser.WEBGL,
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  parent: 'game-container',
  backgroundColor: '#050716',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  dom: {
    createContainer: true,
    pointerEvents: 'none',
  },
  scene: [
    BootScene,
    MenuScene,
    FriendWebPlayScene,
    JoinScene,
    LobbyScene,
    KickedScene,
    LevelSelectScene,
    LeaderboardScene,
    SingleGameScene,
    DailyChallengeScene,
    DailyShareScene,
    CoopGameScene,
    TelephoneGameScene,
    ResultScene,
    DailyResultScene,
    SettingsScene,
    CreditsScene,
  ],
  physics: {
    default: 'arcade',
    arcade: {
      debug: false,
    },
  },
  input: {
    keyboard: true,
    mouse: true,
  },
};
